import { MoreVertical } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { rm, STATUS, timeMY } from "@/lib/api";
import { usePanel } from "@/pages/staff/PanelLayout";

export const StatusPill = ({ status }) => (
  <span data-testid={`status-pill-${status}`} className={`inline-block px-3 py-1 rounded-full text-[11px] font-semibold ${STATUS[status].cls}`}>{STATUS[status].label}</span>
);

const LOY = { belum: "text-slate-400", dihantar: "text-green-600", manual: "text-green-600", gagal: "text-red-600" };

export const canCancel = (o, isAdmin) => o.status !== "batal" && (isAdmin || o.payment_status !== "dibayar");

export function OrderTable({ orders, onAction, onOpen }) {
  const { me } = usePanel();
  const isAdmin = ["admin", "superadmin"].includes(me?.role);
  if (!orders.length) return <p className="text-sm text-slate-500 py-10 text-center" data-testid="orders-empty">Tiada pesanan.</p>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid="orders-table">
        <thead>
          <tr className="text-left text-slate-500 border-b">
            {["# Order", "Pelanggan", "Jumlah", "Masa", "Ambil", "Loyverse", "Status", ""].map((h) => <th key={h} className="py-3 pr-4 font-medium">{h}</th>)}
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={o.id} className="border-b last:border-0 hover:bg-slate-50 cursor-pointer transition-colors" onClick={() => onOpen(o)} data-testid={`order-row-${o.order_no}`}>
              <td className="py-3 pr-4 font-semibold">{o.order_no}</td>
              <td className="py-3 pr-4">{o.customer_name}<div className="text-xs text-slate-500">{o.phone}</div></td>
              <td className="py-3 pr-4 font-semibold">{rm(o.total)}</td>
              <td className="py-3 pr-4">{timeMY(o.created_at)}</td>
              <td className="py-3 pr-4 text-xs">{o.pickup_time}</td>
              <td className={`py-3 pr-4 text-xs font-semibold capitalize ${LOY[o.loyverse_status] || ""}`}>{o.loyverse_status}</td>
              <td className="py-3 pr-4"><StatusPill status={o.status} /></td>
              <td className="py-3" onClick={(e) => e.stopPropagation()}>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <button data-testid={`order-actions-${o.order_no}`} className="p-1.5 rounded hover:bg-slate-200"><MoreVertical className="w-4 h-4" /></button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    {o.status === "batal" ? <DropdownMenuItem disabled data-testid="action-cancelled-note">Pesanan telah dibatalkan</DropdownMenuItem> : <>
                      <DropdownMenuItem data-testid="action-baharu" onClick={() => onAction(o, "status", "baharu")}>Tandakan Baharu</DropdownMenuItem>
                      <DropdownMenuItem data-testid="action-proses" onClick={() => onAction(o, "status", "proses")}>Tandakan Sedang Proses</DropdownMenuItem>
                      <DropdownMenuItem data-testid="action-selesai" onClick={() => onAction(o, "status", "selesai")}>Tandakan Selesai</DropdownMenuItem>
                      {canCancel(o, isAdmin) && <DropdownMenuItem data-testid="action-batal" className="text-rose-600" onClick={() => onAction(o, "status", "batal")}>Batalkan Pesanan</DropdownMenuItem>}
                      <DropdownMenuSeparator />
                      <DropdownMenuItem data-testid="action-loyverse" onClick={() => onAction(o, "loyverse")}>Hantar ke Loyverse (Auto)</DropdownMenuItem>
                      <DropdownMenuItem data-testid="action-mark-loyverse" onClick={() => onAction(o, "mark-loyverse")}>Tanda Sudah Masuk Loyverse</DropdownMenuItem>
                      <DropdownMenuItem data-testid="action-resend-wa" onClick={() => onAction(o, "resend-wa")}>Hantar Semula WhatsApp</DropdownMenuItem>
                    </>}
                  </DropdownMenuContent>
                </DropdownMenu>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
